<template>
  <div class="wrap" @mousemove="dragMove" @mouseup="dragUp">
    <div class="utils_left">
      <div class="spr_sheets">
        <div class="utils_info" v-show="showInfo">
          <div class="top">
            <p><strong>您可以很方便的使用它拼接电影字幕</strong></p>
            <p>推荐使用 Chrome、FireFox、IE11、Edge </p>
            <p>可以给我提Bug： <a href="mailto:474014965@qq.com">Email</a></p>
          </div>
          <dl>
            <dt><strong>使用方法：</strong></dt>
            <dd>
              <p>1、点击【添加屏幕截图】按钮选择图片，可多选</p>
              <p>2、移动手柄调整好要截取的位置</p>
              <p>3、点击右侧【生成预览图】按钮</p>
              <p>4、点击右侧【保存预览图】按钮</p>
            </dd>
          </dl>
        </div>
        <div class="spr_views" v-for="(item, index) in sprSheetsData" v-bind:id="'views' + index">
          <div class="canvas_parent">
            <canvas v-bind:width="item.width" v-bind:height="item.height" v-bind:id="'canvas'+index" :data-index="index"></canvas>
            <div class="canvas_move">
              <span class="close fa fa-close" @click="delView" :data-index="index"></span>
              <span class="go_prev fa fa-arrow-up" @click="onArrowUp" :data-index="index" v-show="index != 0"></span>
              <span class="go_next fa fa-arrow-down" @click="onArrowDown" :data-index="index" v-show="index != (sprSheetsData.length-1)"></span>
            </div>
          </div>
          <div class="drag_top" v-bind:id="'dragTp'+ index" style="top: 90%" v-bind:style="{ top: item.dragTop}"  @mousedown="dragStart" :data-index="index" v-show="index != 0"></div>
          <div class="drag_bot" v-bind:id="'dragBt'+ index" style="top: 100%" @mousedown="dragStart" :data-index="index" v-show="index != 0"></div>
        </div>

        <button v-on:click="addPic">
          <span class="fa fa-plus-square"><strong>添加屏幕截图</strong></span>
        </button>
      </div>

    </div>

    <div class="utils_right">
      <div class="right_box">
        <div class="canvas_thumb">
          <canvas id="showThumbnails" v-show="showThumb"></canvas>
        </div>
        <button v-on:click="createViewShow" v-bind:disabled="btnShow">
          <span class="fa fa-play-circle"><strong>生成预览图</strong></span>
        </button>
        <button v-on:click="saveViewShow" v-bind:disabled="btnSave" style="margin-top:10px;">
          <span class="fa fa-download"><strong>保存预览图</strong></span>
        </button>
        <a id="dl" download="截图.jpg"></a>
      </div>
      <div class="isMobile" v-show="isMobile">仅支持PC端浏览器哦！</div>
    </div>
  </div>
</template>

<script>
import saveAs from '../../static/FileSaver';
export default {
  components: {
  },
  data () {
    return {
      msg: '',
      sprSheetsData:[],   //主体数据
      btnSelect:true,
      btnShow:true,
      btnSave:true,
      showInfo:true,
      isMobile:false,
      dragBarObj:null,
      showThumb: false,
      curViewIndex:0,
      status:0, //1 添加  2 删除  3 移动位置
      dragObjY:0,
      curCanvas:null,
      dragOldXY:{
        y:0
      },
      selectView:null,
      inputEl:null,
    }
  },
  created () {
    this.inputEl = (function () {
      var input = document.createElement("INPUT");
      input.type = 'file';
      input.accept = 'image/png,image/jpeg,image/gif';
      input.multiple = true;
      return input;
    })();
    this.inputEl.addEventListener('change', this._changeHandler, false);

    var ua = navigator.userAgent;
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
      isIphone =!ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
      isAndroid = ua.match(/(Android)\s+([\d.]+)/),
      isMobile = isIphone || isAndroid;
    if(isMobile){
     this.isMobile = true;
    }
  },
  mounted (){
  },
  updated (){
    var s = this;
    //console.dir(this.sprSheetsData);
    const sprData = this.sprSheetsData;
    let views = document.querySelectorAll(".spr_views");

    if (!s.status) return;
    for (let i=0; i<sprData.length; i++){
      var iView = sprData[i];
      let canvas = views[i].querySelector("canvas");
      let ctx = canvas.getContext("2d");
      let sprSheetBox = document.querySelector('.spr_sheets');
      iView.scale = sprSheetBox.offsetWidth / iView.img.width;
      ctx.clearRect(0, 0, iView.width, iView.height);
      ctx.drawImage(iView.img, 0, 0);
      ctx.fillStyle = 'rgba(0,0,0,0.5)';
      /**
       * 判断不是第一个，才重置透明层和拖动杆
       */
      if ( i != 0){
        /**
         * 判断，没有拖动过，那要计算下画出的透明层高度
         * 反之，直接读取存储需要裁剪的高度和Y轴位置
         */
        if (!iView.dragEd){
          iView.viewRect = {
            y: iView.height * .9,
            height: iView.height * .1
          };
          ctx.fillRect(0, 0, iView.width, iView.viewRect.y);
          document.getElementById("dragBt"+i).style.top = iView.dragBot;
        }else{
          ctx.fillRect(0, 0, iView.width, iView.viewRect.y);
          ctx.fillRect(0, iView.viewRect.y+iView.viewRect.height, iView.width, iView.height);

          document.getElementById("dragTp"+i).style.top = iView.dragTop;
          document.getElementById("dragBt"+i).style.top = iView.dragBot;
        }
      }
      ctx.save();
    }
    //console.log("update!");
    s.status = 0;

  },
  methods: {
    /**
     * 删除当前层
     * @param ev { MouseEvent }
     */
    delView: function (ev) {
      var s = this;
      var delIndex = ev.target.dataset.index;
      s.status = 1;
      this.sprSheetsData.splice(delIndex, 1);
      if (this.sprSheetsData.length === 0){
       s.showInfo = true;
       s.showThumb = false;
       s.btnShow = true;
       s.btnSave = true;
      }
    },
    /**
     * 向上移动事件
     * @param ev { MouseEvent }
     */
    onArrowUp: function (ev) {
      var s = this;
      var index = Number(ev.target.dataset.index);
      var thisData = s.sprSheetsData[index];
      var prevData = s.sprSheetsData[index-1];

      this.$set(s.sprSheetsData, index-1, thisData);
      this.$set(s.sprSheetsData, index, prevData);
      s.status = 3;
    },
    /**
     * 向下移动事件
     * @param ev { MouseEvent }
     */
    onArrowDown: function (ev) {
      var s = this;
      var index = Number(ev.target.dataset.index);
      var thisData = s.sprSheetsData[index];
      var nextData = s.sprSheetsData[index+1];
      this.$set(s.sprSheetsData, index, nextData);
      this.$set(s.sprSheetsData, index+1, thisData);
      s.status = 3;
    },
    /**
     * 点击添加图片事件
     * @param event { MouseEvent }
     */
    addPic: function (event) {
      var s = this;
      s.inputEl.click();
    },
    /**
     * 生成缩略图预览
     */
    createViewShow: function () {
      var s = this;
      if (s.btnShow) return;
      var thumHeight = 0;
      var thumCanvasWidth = 500;
      var thumCanvas = document.getElementById("showThumbnails");
      s.showThumb = true;
      var ctx = thumCanvas.getContext('2d');
      var rectAfterHeight = 0;
      var drawY = 0;
      ctx.clearRect(0, 0, 10000, 10000);
      for (var i=0; i<s.sprSheetsData.length; i++){
        var item = s.sprSheetsData[i];
        /**
         * 换算下放到400px宽度的canvas下，被裁切的区域的高度
         */
        if( i == 0){
          rectAfterHeight = ( thumCanvasWidth / item.width ) * item.height;
          item.thumb = {
            y:0,
            height:rectAfterHeight
          }
        }else{
          rectAfterHeight = ( thumCanvasWidth / item.width ) * item.viewRect.height;
          item.thumb = {
            y:s.sprSheetsData[i-1].thumb.height + s.sprSheetsData[i-1].thumb.y,
            height:rectAfterHeight
          }
        }

        thumHeight += rectAfterHeight;
        s.btnSave = false;
      }
      thumCanvas.setAttribute('width', thumCanvasWidth);
      thumCanvas.setAttribute('height', thumHeight);
      /**
       * 画出所有裁切位置
       */
      for (var i=0; i<s.sprSheetsData.length; i++){
        var item = s.sprSheetsData[i];
        ctx.drawImage(item.img, 0, ( i == 0 ? 0 : item.viewRect.y), item.width, ( i == 0 ? item.height : item.viewRect.height), 0, item.thumb.y, thumCanvasWidth, item.thumb.height);
      }


    },
    /**
     * 保存缩略图
     */
    saveViewShow: function (ev) {
      var s = this;
      if (s.btnSave) return;
      function isIE() { //ie?
        if (!!window.ActiveXObject || "ActiveXObject" in window)
          return true;
        else
          return false;
      }
      var canvas = document.getElementById("showThumbnails");
      var ctx = canvas.getContext("2d");
      var btnDl = document.getElementById("dl");
      if (canvas.msToBlob){
        var blob = canvas.msToBlob();
        window.navigator.msSaveBlob(blob, '截图.png');
      }else{
        var dt = canvas.toDataURL('image/jpeg', '1.0');
        dt = dt.replace(/^data:image\/[^;]*/, 'data:application/octet-stream');
        dt = dt.replace(/^data:application\/octet-stream/, 'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=截图.jpg');
        btnDl.href = dt;
        btnDl.click();
      }


    },
    /**
     * 拖动点上事件
     * @param ev
     */
    dragStart: function (ev) {
      var s = this;
      var obj = ev.target;
      var index = Number(obj.getAttribute("data-index"));
      if (index != 0){
        if (ev.target.className === 'drag_top'){
          //console.log("第一个");
        }else{
          //console.log("第2个");
        }
        s.dragBarObj = obj;

        s.selectView = document.getElementById("views"+index);
        s.dragObjY = Number(s.dragBarObj.style.top.replace('%', '')) / 100 * s.selectView.offsetHeight;
        s.dragOldXY.y = ev.y;
        s.curCanvas = document.getElementById("canvas"+index);
        s.curViewIndex = index;
        s.sprSheetsData[index].dragEd = true;
        //console.log(s.curViewIndex);
      }else{

      }

    },
    /**
     * 拖动中事件
     * @param ev
     */
    dragMove: function (ev) {
      var s = this;
      if (s.dragBarObj){
        var viewOffsetTop = s.selectView.offsetHeight;
        var y = ev.y - s.dragOldXY.y;

        s.dragObjY += y;
        if (s.dragObjY > viewOffsetTop){
          s.dragObjY = viewOffsetTop;
        }else if (s.dragObjY < 0){
          s.dragObjY = 0;
        }
        s.dragBarObj.style.top = ( s.dragObjY / viewOffsetTop ) * 100 +"%";
        s.drawCanvas();
        s.dragOldXY.y = ev.y;
      }

    },
    /**
     * 拖动结束事件
     * @param ev
     */
    dragUp: function () {
      var s = this;
      s.dragBarObj = null;
      s.selectView = null;
    },
    /**
     * 拖动过程中，重画透明层方法
     */
    drawCanvas: function () {
      var s = this;
       //第一个操纵杆
      var thisSheet = s.sprSheetsData[s.curViewIndex];
      var dgTop = document.getElementById("dragTp"+s.curViewIndex);
      var dgBot = document.getElementById("dragBt"+s.curViewIndex);

      //重新后去下view和canvas，因为在添加第二章图片的时候，第一个canvas宽度会有变化
      s.selectView = document.getElementById("views"+s.curViewIndex);
      s.curCanvas = document.getElementById("canvas"+s.curViewIndex);


      var dy1 = Number(dgTop.style.top.replace('%', '')) / 100 * s.selectView.offsetHeight;
      var dy2 = Number(dgBot.style.top.replace('%', '')) / 100 * s.selectView.offsetHeight;

      var ctx = s.curCanvas.getContext('2d');
      thisSheet.scale = s.curCanvas.offsetWidth / thisSheet.width;
      //第一块半透明的y
      var alpha1Y = Math.min(dy1, dy2) / thisSheet.scale;
      var alpha2Y = Math.max(dy1, dy2) / thisSheet.scale;
      ctx.clearRect(0,0,s.curCanvas.width, s.curCanvas.height);
      //画底图
      ctx.drawImage(thisSheet.img, 0,0);
      //给canvas画半透明层
      ctx.fillStyle = 'rgba(0,0,0,0.5)';
      ctx.fillRect(0, 0, thisSheet.width, alpha1Y+1);
      //存储下2个操作杆的位置
      thisSheet.dragTop = dgTop.style.top;
      thisSheet.dragBot = dgBot.style.top;
      //设置裁切的区域
      thisSheet.viewRect = {
        y:alpha1Y,
        height:alpha2Y-alpha1Y
      };

      ctx.fillRect(0, alpha2Y+2, thisSheet.width, s.selectView.offsetHeight / thisSheet.scale);
      ctx.fill();
    },
    /**
     * input change 事件
     * @param event
     * @private
     */
    _changeHandler: function (event) {
      var s = this;
      // event.path[0].files;
      var files = event.path ? event.path[0].files : event.target.files;
      window.URL = window.URL || window.webkitURL;

      for (var i=0; i<files.length; i++){
        var src = window.URL.createObjectURL(files[i]);
        //console.log(src);
        s.createView(src, i, files.length);
      }
      s.inputEl.value = "";
      s.btnShow = false;
      s.showInfo = false;
    },
    /**
     * 画选择的图片
     * @param src
     */
    createView: function (src, curIndex, maxLen) {
      var s = this;
      var img = new Image();
      //var pageLeft = document.querySelector(".utils_left");
      img.onload = function () {
        s.sprSheetsData.push({
          width: img.width,
          height: img.height,
          scale:1,
          viewRect:{
            y:0,
            height:0
          },
          img:img,
          dragTop:"90%",
          dragBot:"100%",
          dragEd:false, // 是否已经产生了拖动
          src:src
        });
        s.status = 1;
      };
      img.src = src;
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.isMobile { font-weight: bold; color:#ff0000; }
.utils_info { text-align: left;font-size:14px; padding-bottom:20px; min-height:200px; }
.utils_info .top { line-height: 1.5; }
.utils_info dt { padding:10px 0px 5px 0px;}
.utils_info dd {  line-height: 1.5;}
  .utils_left, .utils_right {  width:50%; height:100%; overflow-scrolling: touch; overflow-x:hidden; float:left; overflow-y: auto;}
  .utils_right { box-sizing: border-box; }
  button {display: block; width:100%; background: #34CFBE; box-shadow: 0px 0px 3px #34CFBE; color:#2c3e50; border:0; border-radius:2px; outline: none; cursor: pointer;}
  button span, button a{  width:100%; font-size:14px; display: block; line-height: 35px; }
  button strong { font-family: Helvetica, 'Pingfang SC', 'microsoft yahei'; display: inline-block; font-weight: normal; }
  button .fa:before { font-size:16px; margin-right:5px; display: inline-block; vertical-align: middle; }
button:disabled { opacity:0.7; cursor: default; }
button:hover { box-shadow: 0px 0px 8px #34CFBE; }
button:hover:disabled { opacity:0.7; box-shadow: 0px 0px 3px #34CFBE; }
  .canvas_thumb { min-height:200px; box-shadow: 0 0 3px #cccccc; background: #ffffff; border:1px solid #ccc; margin-bottom:20px; }
  .spr_sheets,.right_box { width:80%; margin:0 auto; padding:20px 0; }
  .spr_views { position: relative; margin:20px 0; }
  .spr_views canvas { width:100%; display: block;  }
  .canvas_parent {position: relative; }
  #showThumbnails { width:100%; display: block; }
  .canvas_move { position: absolute; right:0; top:10px;}
  .go_prev, .go_next, .close { color:#cccccc; float:right; margin-right:10px; width:40px; height:40px; background: rgba(0, 0, 0, 0.5); font-size:30px; box-sizing: border-box; padding-top:4px; border-radius:5px; cursor: pointer; }
  .drag_top, .drag_bot { position: absolute; width:110%; left:-5%; touch-action: none;}
  .drag_top:hover, .drag_bot:hover { cursor: row-resize;  }
  .drag_top:before, .drag_bot:before { position: absolute; left:0;top:0; content:""; width:100%; height:2px; background: #ff0000; font-size:0;}
  .drag_top:after, .drag_bot:after { position: absolute; right:0; top:-6px; content:""; width:15px; height:15px; background: #f00; border-radius: 0 50% 50% 50%; transform: rotate(-45deg); }
  .drag_top { }
  .drag_bot { }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue